import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { SearchX } from "lucide-react";
import SearchBar from "./SearchBar";
import RuleCard from "./RuleCard";

export default function RegrasGrid({ regras, accent, searchTestid, cardPrefix, placeholder }) {
    const [query, setQuery] = useState("");
    const q = query.trim().toLowerCase();
    const filtered = regras.filter(
        (r) =>
            !q ||
            r.titulo.toLowerCase().includes(q) ||
            r.texto.toLowerCase().includes(q)
    );

    return (
        <div>
            <div className="mb-6 max-w-md">
                <SearchBar
                    value={query}
                    onChange={setQuery}
                    placeholder={placeholder}
                    testid={searchTestid}
                />
            </div>
            {filtered.length === 0 ? (
                <div
                    data-testid={`${cardPrefix}-empty-state`}
                    className="glass-card flex flex-col items-center gap-3 rounded-2xl px-6 py-16 text-center"
                >
                    <SearchX className="h-8 w-8 text-gray-600" />
                    <p className="font-display text-lg font-bold text-gray-300">
                        Nenhuma regra encontrada
                    </p>
                    <p className="text-sm text-gray-500">
                        Tente buscar por outro termo.
                    </p>
                </div>
            ) : (
                <motion.div layout className="grid gap-4 md:grid-cols-2">
                    <AnimatePresence mode="popLayout">
                        {filtered.map((regra, i) => (
                            <RuleCard
                                key={regra.numero}
                                regra={regra}
                                index={i}
                                accent={accent}
                                testid={`${cardPrefix}-${regra.numero}`}
                            />
                        ))}
                    </AnimatePresence>
                </motion.div>
            )}
        </div>
    );
}
